import { useCallback } from 'react';
import { useDatetime } from '../datetime/datetime-provider';
import { useServices } from '../service/services-provider';

export function useResetBookingState() {
  const { setSelectedDay, setSelectedTimeslot } = useDatetime();
  const { setCurrentService } = useServices();

  return useCallback(() => {
    setCurrentService(undefined);
    setSelectedDay(undefined);
    setSelectedTimeslot(undefined);
  }, []);
}
